module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "BlogFooter"
  }, [_c('container', [(_vm.years) ? _c('nav', {
    staticClass: "BlogFooter-yearPicker"
  }, _vm._l((_vm.years), function(year) {
    return _c('router-link', {
      key: year.year,
      ref: "item",
      refInFor: true,
      staticClass: "BlogFooter-yearPickerItem t-mono-xs",
      attrs: {
        "to": year.route
      }
    }, [_vm._v("\n\n        " + _vm._s(year.year) + "\n\n      ")])
  }), 1) : _vm._e(), _vm._v(" "), _c('break', {
    attrs: {
      "size": "2"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a388c5c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlogFooter.vue
// module id = 782
// module chunks = 1474